const initialState = () => ({
  supervisors: [], // Supervisores de una empresa
  supervisorsAsigned: [], // Supervisores asignados a la Cola seleccionada
  admins: [], // Administradores de una empresa
})

export default initialState
